/* unplugin-vue-components disabled */import { render } from "./AccountStat.vue?vue&type=template&id=cbcc9fd0"
import script from "./AccountStat.vue?vue&type=script&lang=js"
export * from "./AccountStat.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__